"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorResponse = exports.ErrorResponseSchema = void 0;
exports.errorResponses = errorResponses;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
const refine_1 = require("../util/refine");
exports.ErrorResponseSchema = zod_1.default.object({
    error: zod_1.default.string(),
});
exports.ErrorResponse = exports.ErrorResponseSchema.refine((refine_1.is));
function errorResponses() {
    return {
        [401]: exports.ErrorResponse,
        [403]: exports.ErrorResponse,
        [404]: null,
    };
}
